"use strict";

function isBrowser() {
  return typeof window !== "undefined" && typeof document !== "undefined";
}

function isNode() {
  return (
    typeof process !== "undefined" && process.versions && process.versions.node
  );
}

if (isBrowser()) {
  module.exports = require("./client/index.js");
} else if (isNode()) {
  module.exports = require("./server/index.js");
} else {
  throw new Error(
    "Unsupported environment: neither browser nor Node.js detected"
  );
}
